@if (ppActivity.data.relatedPointId) {
  <pp-dashlet-activity-relation
    [ppRelatedPointTitle]="ppActivity.data.relatedPointTitle"
    [ppRelationshipType]="ppActivity.data.relationshipType"
    [ppAction]="ppActivity.data.action"
  />
}

@for (change of ppActivity.data.changeList ?? []; track change; let index = $index) {
  <div>
    @if (change.propName === propNames.IMAGES) {
      <pp-dashlet-activity-images [ppChange]="change"></pp-dashlet-activity-images>
    }
    @if (change.propName === propNames.IMAGES360) {
      <pp-dashlet-activity-images360 [ppChange]="change"></pp-dashlet-activity-images360>
    }
    @if (change.propName === propNames.VIDEOS) {
      <pp-dashlet-activity-videos [ppChange]="change"></pp-dashlet-activity-videos>
    }
    @if (change.propName === propNames.DOCUMENTS) {
      <pp-dashlet-activity-documents [ppChange]="change"></pp-dashlet-activity-documents>
    }
    @if (change.propName === propNames.STATUS) {
      <pp-dashlet-activity-status [ppChange]="change"></pp-dashlet-activity-status>
    }
    @if (change.propName === propNames.PRIORITY) {
      <pp-dashlet-activity-priority [ppChange]="change"></pp-dashlet-activity-priority>
    }
    @if (change.propName === propNames.DESCRIPTION && !shouldBeHidden) {
      <pp-dashlet-activity-description [ppChange]="change"></pp-dashlet-activity-description>
    }
    @if (change.propName === propNames.DESCRIPTION_RICH && change.newValue) {
      <pp-dashlet-activity-description-rich
        [ppChange]="change"
      ></pp-dashlet-activity-description-rich>
    }
    @if (change.richText === true) {
      <pp-dashlet-activity-rich-text [ppChange]="change"></pp-dashlet-activity-rich-text>
    }
    @if (change.propName === propNames.TITLE) {
      <pp-dashlet-activity-title [ppChange]="change"></pp-dashlet-activity-title>
    }
    @if (change.propName === propNames.TAGS) {
      <pp-dashlet-activity-tags [ppChange]="change"></pp-dashlet-activity-tags>
    }
    @if (change.propName === propNames.ASSIGNEES) {
      <pp-dashlet-activity-assignees
        [ppChange]="change"
        [ppAllUsers]="ppAllUsers"
      ></pp-dashlet-activity-assignees>
    }
    @if (change.propName === propNames.CUSTOM_FIELD && !change.richText) {
      <pp-dashlet-activity-custom-field [ppChange]="change"></pp-dashlet-activity-custom-field>
    }
    @if (change.propName === propNames.CUSTOM_FIELD_SUB_VALUE && !change.richText) {
      <pp-dashlet-activity-custom-field-sub-value
        [ppChange]="change"
      ></pp-dashlet-activity-custom-field-sub-value>
    }
    @if (
      change.propName === propNames.PIN ||
      change.propName === propNames.ADDITIONAL_PINS ||
      change.propName === propNames.PINS ||
      change.propName === propNames.POLYGONS
    ) {
      <pp-dashlet-activity-location></pp-dashlet-activity-location>
    }
    @if (change.propName === propNames.FLAGGED) {
      <pp-dashlet-activity-flag [ppChange]="change"></pp-dashlet-activity-flag>
    }
  </div>
}
